module.exports = __webpack_public_path__ + "img/suits.a6ef14cc.svg";